import {ApiUrls} from 'shared/config/model/urls';

import {createApi} from '@reduxjs/toolkit/query/react';
import httpBaseQuery from 'shared/api/rtk-query/httpBaseQuery';
import {ICountry} from 'entities/location';

export const countryAPI = createApi({
    reducerPath: 'countryAPI',
    baseQuery: httpBaseQuery(),
    tagTypes: ['Country'],
    endpoints: (build) => ({
        getCountries: build.query<ICountry[], number>({
            query: (groupId) => ({
                path: ApiUrls.COUNTRIES(groupId),
            }),
            providesTags: ['Country'],
        }),
    }),
});